const opacity = {
  10: "0.1",
}

module.exports = {
  opacity,
}

exports.default = opacity
